import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=5e6994fc"
import script from "./Presupuestos.vue?vue&type=script&lang=js"
export * from "./Presupuestos.vue?vue&type=script&lang=js"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=5e6994fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports